"use strict";

exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-overlays/~/dom-helpers/query/isWindow.js
 ** module id = ./node_modules/react-overlays/node_modules/dom-helpers/query/isWindow.js
 ** module chunks = 0
 **/